import { useState } from "react";

import { ExistingAPIs } from "./IndividualAPI/ExistingAPIs";

import { Button } from "V2.0/common/button";

import { IndividualAPI } from "./IndividualAPI";

import { PlusCircleIcon } from "@heroicons/react/16/solid";
import { individualAPI } from "./IndividualAPI/models/individualAPI";
import { EnableCustomAPIs } from "./EnableCustomAPIs";
import { useCustomAPIs } from "./hooks/useCustomAPI";
import { PlusIcon } from "@heroicons/react/24/outline";

const MODE = {
  ADD: "ADD",
  EDIT: "EDIT",
  NONE: null,
};

export function CustomAPIs({
  workspaceId,
  customAPIs,
  assistantId,
  syncAssistant,
  locked,
  contextManagementSettings,
  languageSettings,
}) {
  const [mode, setMode] = useState({
    mode: MODE.NONE,
    item: null,
    index: null,
  });

  const {
    customAPIsArray,
    customAPIsEnabled,
    updateCustomApis,
    updateCustomApisArray,
    removeCustomApisArray,
    addCustomApisArray,
  } = useCustomAPIs({ workspaceId, assistantId, customAPIs, syncAssistant });

  return (
    <div className="flex flex-col gap-y-4 border rounded-lg m-4">
      <div className="flex items-center justify-between px-6 py-4 bg-gray-50 rounded-t-lg">
        <div className="flex items-end gap-x-2">
          <p className="font-semibold text-base">Custom APIs</p>
          <div className="self-end">
            {!locked && (
              <EnableCustomAPIs
                customAPIsEnabled={customAPIsEnabled}
                updateAssistantCustomAPI={updateCustomApis}
              />
            )}
          </div>
        </div>
        {!mode.mode && !locked && (
          <Button
            className=""
            color="white"
            onClick={() => {
              setMode({
                mode: MODE.ADD,
                item: individualAPI,
                index: null,
              });
            }}
          >
            <PlusIcon />
            Add Custom API
          </Button>
        )}
      </div>
      <div className="min-h-96 h-full max-h-max px-6">
        {(!mode.mode || locked) && (
          <ExistingAPIs
            customApis={customAPIsArray}
            onDelete={locked ? () => {} : (id) => removeCustomApisArray(id)}
            setActiveItem={(item, index) =>
              setMode({ mode: MODE.EDIT, item, index })
            }
            locked={locked}
          />
        )}
        {mode.mode === MODE.EDIT && !locked && (
          <IndividualAPI
            item={mode.item}
            onConfirm={(data) => updateCustomApisArray(mode.item._id, data)}
            goBack={() => setMode({ mode: MODE.NONE, item: null, index: null })}
            contextCharacteristics={contextManagementSettings?.characteristics ?? []}
            allAPIs={customAPIsArray}
            languageSettings={languageSettings}
          />
        )}
        {mode.mode === MODE.ADD && !locked && (
          <IndividualAPI
            onConfirm={(data) => addCustomApisArray(data)}
            item={mode.item}
            goBack={() => setMode({ mode: MODE.NONE, item: null, index: null })}
            contextCharacteristics={contextManagementSettings?.characteristics ?? []}
            allAPIs={customAPIsArray}
            languageSettings={languageSettings}
          />
        )}
      </div>
    </div>
  );
}
